import store from '@/store'

export function isAdminEmail() {
    let allowedEmails = []
    try {
        allowedEmails = JSON.parse(process.env.VUE_APP_ADMIN_EMAILS || '[]')
    } catch (e) {
        allowedEmails = []
    }
    const currentUserEmail = store.state.currentUser?.email || null
    return allowedEmails.includes(currentUserEmail)
}

export function adminRouteGuard(to, from, next) {
    isAdminEmail() ? next() : next(false)
}
